module.exports = __webpack_public_path__ + "static/glabrezu-6f85a3242d25449da52fbcf1a8a838aa.jpg";